export const copilotDropdownFeatureFlags = [
  'email-translation',
  'agent-copilot-improve-writing',
  'agent-copilot-style-guides',
] as const;
